import React from 'react';

interface AdminNavigationProps {
    activeTab: 'dashboard' | 'email' | 'campaigns' | 'unsubscribe' | 'contacts' | 'states' | 'users' | 'settings';
    onTabChange: (tab: 'dashboard' | 'email' | 'campaigns' | 'unsubscribe' | 'contacts' | 'states' | 'users' | 'settings') => void;
}

const AdminNavigation: React.FC<AdminNavigationProps> = ({ activeTab, onTabChange }) => {
    return (
        <div className="admin-nav-tabs">
            <button
                className={`admin-tab ${activeTab === 'dashboard' ? 'active' : ''}`}
                onClick={() => onTabChange('dashboard')}
            >
                📊 Dashboard
            </button>
            <button
                className={`admin-tab ${activeTab === 'email' ? 'active' : ''}`}
                onClick={() => onTabChange('email')}
            >
                📧 Email Marketing
            </button>
            <button
                className={`admin-tab ${activeTab === 'campaigns' ? 'active' : ''}`}
                onClick={() => onTabChange('campaigns')}
            >
                📬 Email Campaigns
            </button>
            <button
                className={`admin-tab ${activeTab === 'unsubscribe' ? 'active' : ''}`}
                onClick={() => onTabChange('unsubscribe')}
            >
                🚫 Unsubscribe
            </button>
            <button
                className={`admin-tab ${activeTab === 'contacts' ? 'active' : ''}`}
                onClick={() => onTabChange('contacts')}
            >
                👤 Email Contacts
            </button>
            <button
                className={`admin-tab ${activeTab === 'states' ? 'active' : ''}`}
                onClick={() => onTabChange('states')}
            >
                🗺️ State Dashboard
            </button>
            <button
                className={`admin-tab ${activeTab === 'users' ? 'active' : ''}`}
                onClick={() => onTabChange('users')}
            >
                👥 Users
            </button>
            <button
                className={`admin-tab ${activeTab === 'settings' ? 'active' : ''}`}
                onClick={() => onTabChange('settings')}
            >
                ⚙️ Settings
            </button>
        </div>
    );
};

export default AdminNavigation;

